import React from 'react';
import styles from './FJLoading.module.less';
import classNames from 'classnames'
import FJLoadingImg from './FJLoadingImg'

function FJLoading(props) {
  let isFull = props && props.isFull;
  return (
    <div className={classNames(styles.loading_box, isFull && styles.loading_full)}>
      <FJLoadingImg className={ classNames( styles.img )} />
    </div>
  );
}

export default FJLoading;
